





























































































































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import moment from 'moment';
import ButtonPanel from '@/components/menu/panel/ButtonPanel.vue';
import IconButton from '@/components/atom/button/IconButton.vue';
import Datepicker from '@/components/datepicker/DatePicker.vue';
import {loginModule} from '@/store/authentication/login';
import NormalButton from '@/components/atom/button/NormalButton.vue';
import AmountField from '@/components/atom/input/AmountField.vue';
import ConfirmDialog from '@/components/atom/dialog/ConfirmDialog.vue';
import AlertDialog from '@/components/atom/dialog/AlertDialog.vue';
import OtaruRegisterDestroyDialog from '@/views/custom/otaru/destroy/OtaruRegisterDestroyDialog.vue';
import {期限切れ破棄破損ダイアログ種類型} from '@/type/custom/otaru/destroy/otaruDestroyDialog.ts';
import {期限切れ破棄破損型} from '@/type/custom/otaru/destroy/otaruDestroy.ts';
import {期限切れ破棄破損一覧型} from '@/type/custom/otaru/destroy/otaruDestroyList.ts';
import otaruDestroyApi from '@/infrastructure/api/custom/otaru/OtaruDestroyApi.ts';
import {期限切れ破棄破損検索条件型, 期限切れ破棄破損検索条件初期値} from '@/type/custom/otaru/destroy/otaruDestroyListSearchCriteria.ts';
import 期限切れ破棄破損検索条チェッカー from '@/type/custom/otaru/destroy/validator/期限切れ破棄破損検索チェッカー';

import api from '@/infrastructure/api/api';
import download from '@/infrastructure/api/download';
import {progress} from '@/script/progress';

@Component({
  components: {
    Datepicker,
    ButtonPanel,
    IconButton,
    NormalButton,
    AmountField,
    ConfirmDialog,
    AlertDialog,
    RegisterDialog: OtaruRegisterDestroyDialog,
  },
  filters: {
    日付フォーマット(date: Date): string | null {
      if (date == null) {
        return '';
      }
      return moment(date).format('YYYY/MM/DD');
    },
    floatAmountFormat(value: number): string {
      if (!value) {
        return '';
      }
      return value.toLocaleString('ja-JP', {minimumFractionDigits: 3});
    },
    priceFormat(value: number): string {
      if (!value) {
        return '';
      }
      return value.toLocaleString('ja-JP', {minimumFractionDigits: 3});
    },
  },
})
export default class OtaruDestroyList extends Vue {
  アラートメッセージ: string[] = [];

  期限切れ破棄破損一覧: 期限切れ破棄破損型[] = [];

  選択期限切れ破棄破損: 期限切れ破棄破損型 | null = null;

  検索条件: 期限切れ破棄破損検索条件型 = 期限切れ破棄破損検索条件初期値();

  選択行番号: number | null = null;

  選択期限切れ破棄破損ダイアログ種類: 期限切れ破棄破損ダイアログ種類型 | null = null;

  checker: 期限切れ破棄破損検索条チェッカー | null = null;

  検索条件エラー判定(項目名: string): boolean {
    if (this.checker == null) return false;
    return this.checker.hasError(項目名);
  }

  async 検索する() {
    this.checker = new 期限切れ破棄破損検索条チェッカー(this.検索条件);
    if (this.checker.hasErrors()) {
      this.アラートメッセージ = this.checker.errorMessages();
      this.$modal.show('期限切れ／破棄破損アラート');
      return;
    }
    await this.期限切れ破棄破損を検索する();
  }

  async 期限切れ破棄破損を検索する() {
    this.選択行番号 = null;
    this.選択期限切れ破棄破損 = null;

    const 検索上限値付き期限切れ破棄破損一覧 = await otaruDestroyApi.期限切れ破棄破損を検索する(this.検索条件);

    this.期限切れ破棄破損一覧 = 検索上限値付き期限切れ破棄破損一覧.期限切れ破棄破損一覧;

    if (this.期限切れ破棄破損一覧.length === 0) {
      this.showAlert(['検索結果が0件です。']);
      return;
    }
    if (検索上限値付き期限切れ破棄破損一覧.アラートメッセージ) {
      this.showAlert([検索上限値付き期限切れ破棄破損一覧.アラートメッセージ]);
      return;
    }
  }

  削除ダイアログを開く(): void {
    this.$modal.show('削除ダイアログ');
  }

  削除する(): void {
    if (this.選択行番号 !== null) {
      const 期限切れ破棄破損シーケンス番号 = this.期限切れ破棄破損一覧[this.選択行番号].期限切れ破棄破損シーケンス番号;
      const 更新バージョン = this.期限切れ破棄破損一覧[this.選択行番号].更新バージョン;
      otaruDestroyApi.期限切れ破棄破損を削除する(期限切れ破棄破損シーケンス番号, 更新バージョン)
        .then(() => this.期限切れ破棄破損を検索する())
        .catch((error: any) => {
          this.showAlert([error.data.message]);
        });
    }
    this.ダイアログを閉じる('削除ダイアログ');
  }

  行が選択されている(行番号: number) {
    if (this.選択行番号 === null) return false;
    return this.選択行番号 === 行番号;
  }

  行を選択する(行番号: number): void {
    this.選択行番号 = 行番号;
  }

  クリアダイアログを開く() {
    this.$modal.show('クリア確認ダイアログ');
  }

  クリアする(): void {
    this.アラートメッセージ = [];
    this.期限切れ破棄破損一覧 = [];

    this.選択期限切れ破棄破損 = null;
    this.検索条件 = 期限切れ破棄破損検索条件初期値();

    this.選択行番号 = null;

    this.ダイアログを閉じる('クリア確認ダイアログ');
  }

  クリア確認ダイアログを閉じる() {
    this.ダイアログを閉じる('クリア確認ダイアログ');
  }

  ダイアログを閉じる(name: string): void {
    this.$modal.hide(name);
  }

  Excel出力確認ダイアログを開く(): void {
    this.checker = new 期限切れ破棄破損検索条チェッカー(this.検索条件);
    if (this.checker.hasErrors()) {
      this.アラートメッセージ = this.checker.errorMessages();
      this.$modal.show('期限切れ／破棄破損アラート');
      return;
    }
    this.$modal.show('Excel出力確認ダイアログ');
  }

  showAlert(message: string[]): void {
    this.アラートメッセージ = message;
    this.$modal.show('期限切れ／破棄破損アラート');
  }

  登録モーダルを開く(): void {
    this.選択期限切れ破棄破損ダイアログ種類 = new 期限切れ破棄破損ダイアログ種類型('期限切れ破棄破損登録', false, null);
    this.$modal.show('期限切れ破棄破損ダイアログ画面');
  }

  登録モーダルを閉じる(再検索: boolean): void {
    this.$modal.hide('期限切れ破棄破損ダイアログ画面');
    if (再検索) this.期限切れ破棄破損を検索する();
  }

  async 更新モーダルを開く(行番号: number): Promise<void> {
    const 期限切れ破棄破損シーケンス番号 = this.期限切れ破棄破損一覧[行番号].期限切れ破棄破損シーケンス番号;
    this.選択期限切れ破棄破損ダイアログ種類 = new 期限切れ破棄破損ダイアログ種類型('期限切れ破棄破損更新', false, 期限切れ破棄破損シーケンス番号);
    this.$modal.show('期限切れ破棄破損ダイアログ画面');
  }

  更新モーダルを閉じる(再検索: boolean): void {
    this.$modal.hide('期限切れ破棄破損ダイアログ画面');
    if (再検索) this.期限切れ破棄破損を検索する();
  }

  async 複写モーダルを開く(): Promise<void> {
    if (this.選択行番号 === null) return;
    const 期限切れ破棄破損シーケンス番号 = this.期限切れ破棄破損一覧[this.選択行番号].期限切れ破棄破損シーケンス番号;
    this.選択期限切れ破棄破損ダイアログ種類 = new 期限切れ破棄破損ダイアログ種類型('期限切れ破棄破損複写', true, 期限切れ破棄破損シーケンス番号);
    this.$modal.show('期限切れ破棄破損ダイアログ画面');
  }

  複写モーダルを閉じる(再検索: boolean): void {
    this.$modal.hide('期限切れ破棄破損ダイアログ画面');
    if (再検索) this.期限切れ破棄破損を検索する();
  }

  async Excelファイルを出力する(): Promise<void> {
    const Excel出力処理 = async (): Promise<void> => {
      await download.小樽市立期限切れ破棄破損一覧を出力する('期限切れ破棄破損一覧.xlsx', this.検索条件)
        .catch((error: any) => {
          this.アラートメッセージ = [error.data.message];
          this.$modal.show('期限切れ／破棄破損アラート');
        });
    };

    await progress(Excel出力処理);

    this.ダイアログを閉じる('Excel出力確認ダイアログ');
  }

}
